import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useFormState } from '@carboledger/ui';
import { useGetCustomerShippingDetailsQuery } from '@/lib/api/lookupsApi';
import { buildLookupOptions } from '@/config/formOptions';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';
import { DependentDropdownField } from './DependentDropdownField';

/**
 * Props:
 *   label     overrides the default wording; the add/edit form keeps its own
 *   disabled  locked while only the quantity may change
 */
export const ShippingToField = ({ label, disabled = false }) => {
  const t = useTranslations();
  const { values } = useFormState();

  const { data: details = EMPTY_LIST, isSuccess } = useGetCustomerShippingDetailsQuery(
    values.soldToId || skipToken,
  );

  const options = useMemo(() => buildLookupOptions(details), [details]);

  return (
    <DependentDropdownField
      name="shippingToId"
      label={label ?? t('FORM_SHIPPING_TO_OPTIONAL')}
      placeholder={t('COMMON_SELECT')}
      emptyMessage={values.soldToId ? t('FORM_SHIPPING_TO_EMPTY') : t('FORM_SELECT_CUSTOMER_FIRST')}
      options={options}
      required={false}
      disabled={disabled}
      // An in-flight list is empty and would wipe Edit's prefilled site.
      ready={isSuccess}
    />
  );
};
